import axios from "axios";
import { API_URL } from "../../../core/config/env";
import {
    getHeaders,
    objectToQueryParameters,
    processError,
} from "../../../core/helpers/service-helper";

/**
 * @param {object} reserva
 * @returns {Promise<object[]>}
 */
export const reservar = async (reserva) => {
    try {
        const resp = await axios.post(`${API_URL}/reservas/reservar`, reserva, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const obtenerReservaPorId = async (id) => {
    try {
        const resp = await axios.get(`${API_URL}/reservas/${id}`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const obtenerReservas = async (params = {}) => {
    try {
        params = objectToQueryParameters(params);
        const resp = await axios.get(`${API_URL}/reservas?${params}`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const obtenerRecursos = async () => {
    try {
        const resp = await axios.get(`${API_URL}/reservas/recursos?status=1`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};
